import { defineComponent as a, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "2c432b50-8c8c-433e-8423-0cfcd341a15f" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#2c432b50-8c8c-433e-8423-0cfcd341a15f)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#338af3",
  d: "M0 0h512v512H0Z"
}, null, -1), g = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "m312 256 116-38-72 99V195l72 99zm8 69a128 128 0 1 1 0-137 102 102 0 1 0 0 137z"
}, null, -1), v = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ a({
  __name: "cn-xj",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), c = o(() => -e.strokeWidth), n = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (s(), i("title", k, d(e.flagName), 1)) : f("", !0),
        p,
        g
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=cn-xj-c12d8e14.js.map
